import type { UsageTerms } from '../types';

/** アップロード画面（右ペイン）と Detail ページで共有する「投稿者以外の利用」の要約表示ロジック。 */

/** 公開ポーズの利用可否についての固定の案内文。 */
export const USAGE_TERMS_LEAD_TEXT = '公開ポーズは連携アプリでのダウンロード・利用ができます。';

export interface UsageSummaryRow {
  label: string;
  ok: boolean;
  okText?: string;
  ngText?: string;
}

/** 「暴力表現での利用: NG」形式の一覧行。 */
export function usageSummaryRows(terms: UsageTerms): UsageSummaryRow[] {
  return [
    { label: '暴力表現での利用', ok: terms.violent },
    { label: '性的表現での利用', ok: terms.sexual },
    { label: '法人利用', ok: terms.corporate },
    { label: '個人の商用利用', ok: terms.commercial },
    { label: '再配布', ok: terms.redistribute },
    { label: '改変', ok: terms.modify },
    { label: 'クレジット表記', ok: !terms.creditRequired, okText: '不要', ngText: '必要' },
  ];
}
